/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://md3m7ksu4nhg5mk2gy7axtokku.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-ctsnpilruvb7zgl5dvllvvrwoi",
    "aws_cognito_identity_pool_id": "us-west-2:53564f35-389f-4171-9e2b-f698b4e65d9b",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_nRYxaYkP9",
    "aws_user_pools_web_client_id": "3thkgusgu7b1tpt2i5utv9fuvv",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "amplify-processplanner-storage183655-prod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
